module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "flex flex-row items-center mobile-flex pl2 pr2 pb2",
    on: {
      "click": _vm.goBack
    }
  }, [_c('arrow-back1'), _vm._v(" "), _c('h3', {
    staticClass: "ml3 f4 cera-round-pro"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('accountsettings.personalinformationheader', {
    personalinformationheader: 'Personal Information'
  })))])], 1), _vm._v(" "), (!_vm.showNameModal) ? _c('div', {
    staticClass: "pv2 ph3 mv2 mh0 flex flex-column justify-center items-start mobile-row"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('span', {
    staticClass: "silver-element"
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.legalname', {
    legalname: 'Legal Name'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-between w-100"
  }, [_c('span', {
    staticClass: "data",
    class: {
      'modal-opened-row-text': _vm.showNameModal
    }
  }, [_vm._v(_vm._s(((this.user.first_name) + " " + (this.user.last_name))) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "color-theme pointer data",
    on: {
      "click": _vm.openNameModal
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.edit', {
    edit: 'Edit'
  })))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNameModal),
      expression: "showNameModal"
    }],
    staticClass: "row-edit mv2 desktop modal-opened-row"
  }, [_c('span', {
    staticClass: "elementLeft modal-opened-row-text"
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.editlegalname', {
    editlegalname: 'Edit Legal Name'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "modal w-75"
  }, [_c('form', {
    staticClass: "flex-column",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.firstname', {
    firstname: 'FIRST NAME'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first_name),
      expression: "first_name"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "first_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.lastname', {
    lastname: 'LAST NAME'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.last_name),
      expression: "last_name"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "last_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-row justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 cancel",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 save",
    attrs: {
      "disabled": !_vm.canUpdateName,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateName.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n          ")])], 1)])])]), _vm._v(" "), (_vm.showNameModal) ? _c('ak-modal', {
    staticClass: "modal flex-row mobile w-75",
    attrs: {
      "title": "Edit your name"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('form', {
    staticClass: "flex-column mh3 mt4",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('accountsettings.editlegalname', {
    editlegalname: 'Edit Legal Name'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.firstname', {
    firstname: 'FIRST NAME'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.first_name),
      expression: "first_name"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "first_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.lastname', {
    lastname: 'LAST NAME'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.last_name),
      expression: "last_name"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "last_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.last_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex mh4 flex-row pb3 justify-between",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "disabled": !_vm.canUpdateName,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateName.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n        ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "line mh3"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditAddress),
      expression: "!isEditAddress"
    }],
    staticClass: "pv2 ph3 mv2 mh0 flex flex-column justify-center items-start mobile-row"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('span', {
    staticClass: "silver-element"
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.address', {
    address: 'Address'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-between w-100"
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(this.user.street) + ",\n      " + _vm._s(this.user.apt) + " " + _vm._s(this.user.city) + ", " + _vm._s(this.user.state) + " " + _vm._s(this.user.zip))]), _vm._v(" "), _c('span', {
    staticClass: "color-theme pointer data",
    on: {
      "click": function($event) {
        _vm.isEditAddress = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.edit', {
    edit: 'Edit'
  })))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditAddress),
      expression: "isEditAddress"
    }],
    staticClass: "row-edit desktop mv2 modal-opened-row-address"
  }, [_c('span', {
    staticClass: "elementLeft modal-opened-row-text"
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.editaddress', {
    editaddress: 'Edit your address'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "modal w-75"
  }, [_c('div', {
    staticClass: "flex-column",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.street', {
    street: 'STREET'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.street),
      expression: "street"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "street",
      "type": "text"
    },
    domProps: {
      "value": (_vm.street)
    },
    on: {
      "change": _vm.updateAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.street = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mv2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.unit', {
    unit: 'UNIT'
  })) + " #")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apt),
      expression: "apt"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "apt",
      "type": "text"
    },
    domProps: {
      "value": (_vm.apt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.apt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mv2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.city', {
    city: 'CITY'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "city",
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mv2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.state', {
    state: 'STATE / PROVINCE / TERRITORY'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "state",
      "type": "text"
    },
    domProps: {
      "value": (_vm.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mv2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.zip', {
    zip: 'ZIP CODE'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "zip",
      "type": "text"
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 inter flex flex-row justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 cancel",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 save",
    attrs: {
      "disabled": !_vm.canUpdateAddress,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeAddress.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n          ")])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditAddress),
      expression: "isEditAddress"
    }],
    staticClass: "mobile mh3 mt3"
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "mb3"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('accountsettings.editaddress', {
    editaddress: 'Edit your address'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex-column",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt2 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.street', {
    street: 'STREET'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.street),
      expression: "street"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "street",
      "type": "text"
    },
    domProps: {
      "value": (_vm.street)
    },
    on: {
      "change": _vm.updateAddress,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.street = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mv2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.unit', {
    unit: 'UNIT'
  })) + " #")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apt),
      expression: "apt"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "apt",
      "type": "text"
    },
    domProps: {
      "value": (_vm.apt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.apt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mv2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.city', {
    city: 'CITY'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city),
      expression: "city"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "city",
      "type": "text"
    },
    domProps: {
      "value": (_vm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mv2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.state', {
    state: 'STATE / PROVINCE / TERRITORY'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "state",
      "type": "text"
    },
    domProps: {
      "value": (_vm.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.state = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt2 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.zip', {
    zip: 'ZIP CODE'
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zip),
      expression: "zip"
    }],
    staticClass: "input-reset ba b--black-20 pa2 db w-100 br1",
    attrs: {
      "id": "zip",
      "type": "text"
    },
    domProps: {
      "value": (_vm.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zip = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex inter flex-row pb3 mh3 justify-between"
  }, [_c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "disabled": !_vm.canUpdateAddress,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeAddress.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n          ")])], 1)])])]), _vm._v(" "), _c('hr', {
    staticClass: "line mh3"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showBirthdayInput),
      expression: "!showBirthdayInput"
    }],
    staticClass: "pv2 ph3 mv2 mh0 flex flex-column justify-center items-start mobile-row"
  }, [_c('div', {
    staticClass: "flex flex-column"
  }, [_c('span', {
    staticClass: "silver-element"
  }, [_vm._v(_vm._s(_vm.$t('accountsettings.dateofbirth', {
    dateofbirth: 'Date of Birth'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row justify-between w-100"
  }, [_c('span', {
    staticClass: "data",
    class: {
      'modal-opened-row-text': _vm.showBirthdayInput
    }
  }, [_vm._v(_vm._s(_vm.birth_day) + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "color-theme pointer data",
    on: {
      "click": _vm.openChangeBirthdayInput
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.edit', {
    edit: 'Edit'
  })))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBirthdayInput),
      expression: "showBirthdayInput"
    }],
    staticClass: "row-edit mv2 desktop modal-opened-birthday"
  }, [_c('span', {
    staticClass: "elementLeft modal-opened-row-text"
  }, [_vm._v("Edit Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "modal w-75"
  }, [_c('form', {
    staticClass: "flex-column",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mt3 mb3 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("DATE OF BIRTH")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birth_day),
      expression: "birth_day"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "birth_day",
      "type": "date"
    },
    domProps: {
      "value": (_vm.birth_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.birth_day = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex flex-row justify-between justify-end-ns",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "mr3 flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 cancel",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grow flex-grow-off-ns"
  }, [_c('ak-button', {
    staticClass: "modal-button inter fw6 save",
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateDateofBirth.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n          ")])], 1)])])]), _vm._v(" "), (_vm.showBirthdayInput) ? _c('div', {
    staticClass: "modal flex-row mobile w-75",
    attrs: {
      "title": "Edit your name"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('form', {
    staticClass: "flex-column mh3 mt4",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb2 flex-grow mh3-ns"
  }, [_c('label', {
    staticClass: "f6 b db mb2 label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.birth_day),
      expression: "birth_day"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb1 db w-100 br1",
    attrs: {
      "id": "birth_day",
      "type": "date"
    },
    domProps: {
      "value": (_vm.birth_day)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.birth_day = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex mh4 flex-row pb3 justify-between",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.cancel', {
    cancel: 'Cancel'
  })) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "w-48"
  }, [_c('ak-button', {
    staticClass: "modal-button inter",
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateDateofBirth.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('edit.save', {
    save: 'Save'
  })) + "\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb3"
  }, [_c('span', [_vm._v("Edit Date of Birth")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72b7c081","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/screens/personal-information/PersonalInformation.vue
// module id = 1031
// module chunks = 0